let phone = null;
export const PHONE_UTILS = {
    setPhoneInstance: (p) => (phone = p),
    getPhone: () => phone,
};



// WEBPACK FOOTER //
// ./src/utils/phone.js